<script lang="ts">
	import { clickOutside } from '../actions';
	import { colors } from '../theme/colors';
	import { attrValue } from '../utils/html';

	export let isOpen = false;
	export let close: () => void = null;
	export let withArrow = false;
	export let position: 'left' | 'center' | 'right' = 'left';
	export let triggerRef = null;
	export let classNames = '';

	let arrowStyleVar = `--arrow-border-color: ${colors['grey-light']}; --arrow-bg-color: ${colors['white']}`;
</script>

{#if isOpen}
	<div
		class="dropdown"
		style={arrowStyleVar}
		class:with-arrow={withArrow}
		class:is-positioned-left={position === 'left'}
		class:is-positioned-center={position === 'center'}
		class:is-positioned-right={position === 'right'}
		use:clickOutside={{ action: close, disabled: !isOpen, excludedRefs: [triggerRef] }}
	>
		<div
			class={attrValue([
				'inner rounded-md p-3',
				classNames,
				'inner',
				'border border-grey-light bg-white'
			])}
		>
			<slot />
		</div>
	</div>
{/if}

<style lang="postcss">
	.dropdown {
		top: 100%;
		--dropdown-padding-top: 10px;
		z-index: theme('zIndex.dropdown');
		padding-top: var(--dropdown-padding-top);
		@apply absolute;
		width: max-content;
	}

	.inner {
		--dropdown-after-content: none;
	}

	.with-arrow {
		--dropdown-padding-top: 10px;
	}

	.with-arrow .inner {
		--dropdown-after-content: '';
	}

	.dropdown.is-positioned-left {
		@apply left-0;
		--arrow-left-position: 15%;
	}

	.dropdown.is-positioned-center {
		@apply left-1/2 transform -translate-x-1/2;
		--arrow-left-position: 50%;
	}

	.dropdown.is-positioned-right {
		@apply right-0;
		--arrow-left-position: 85%;
	}

	.inner:after,
	.inner:before {
		content: var(--dropdown-after-content);
		display: block;
		position: absolute;
		width: 0;
		height: 0;
		border-style: solid;
		transform: translateX(-50%);
	}

	.inner:after {
		top: calc(-17px + var(--dropdown-padding-top));
		border-color: transparent transparent var(--arrow-bg-color) transparent;
		border-width: 9px;
		left: var(--arrow-left-position);
	}

	.inner:before {
		top: calc(-19px + var(--dropdown-padding-top));
		border-color: transparent transparent var(--arrow-border-color) transparent;
		border-width: 10px;
		left: var(--arrow-left-position);
	}
</style>
